<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.banner')"
    resource="banners"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BANNER_KINDS, BANNER_PAGE_POSITIONS } from '@/constants';
import _ from 'lodash';

@Component
export default class Banners extends Vue {
  @Prop(String) type;

  // change nothing
  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'kind_eq',
        label: this.$t('banner.kind'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: _.map(BANNER_KINDS, (value) => ({ label: this.$t(`banner.kinds.${value}`), value: value }))
          }
        }
      },
      {
        prop: 'page_position_eq',
        label: this.$t('banner.pagePosition'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: _.map(BANNER_PAGE_POSITIONS, (value) => ({ label: this.$t(`banner.pagePositions.${value}`), value: value }))
          }
        }
      },
    ]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'image',
        label: this.$t('banner.image'),
        width: 120,
        renderCell: 'storageAttachment',
      },
      {
        prop: 'kind',
        label: this.$t('banner.kind'),
        minWidth: 135,
        renderCell: (h, { props: { value } }) => {
          return <el-tag>{this.$t(`banner.kinds.${value}`)}</el-tag>;
        },
      },
      {
        prop: 'page_position',
        label: this.$t('banner.pagePosition'),
        renderCell: (h, { props: { value } }) => {
          return <el-tag>{this.$t(`banner.pagePositions.${value}`)}</el-tag>;
        },
      },
      {
        prop: 'position',
        label: this.$t('banner.position'),
      },
      {
        prop: 'target.url',
        label: 'Target url'
      },
      type === 'show' && {
        prop: 'created_at',
        label: this.$t('createdAt'),
        renderCell: 'time',
      },
      type === 'show' && {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        renderCell: 'time',
      },
    ].filter(Boolean)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data }) {
    return [
      {
        prop: 'image',
        label: this.$t('banner.image'),
        width: 120,
        renderCell: {
          required: true,
          component: 'upload',
          hint: `${this.$t('suggestSize')}: 750x422`,
          props: {
            cropper: {
              width: 750,
              height: 422
            }
          }
        }
      },
      {
        prop: 'kind',
        label: this.$t('banner.kind'),
        renderCell: {
          required: true,
          component: 'select',
          props: {
            options: _.map(BANNER_KINDS, (value) => ({ label: this.$t(`banner.kinds.${value}`), value: value }))
          }
        }
      },
      {
        prop: 'page_position',
        label: this.$t('banner.pagePosition'),
        renderCell: {
          required: true,
          component: 'select',
          props: {
            options: _.map(BANNER_PAGE_POSITIONS, (value) => ({ label: this.$t(`banner.pagePositions.${value}`), value: value }))
          }
        }
      },
      {
        prop: 'position',
        label: this.$t('banner.position'),
        renderCell: {
          component: 'input',
          hint: this.$t('hints.positionColumn'),
          props: {
            type: 'number'
          }
        },
      },
      data.kind !== 'image' && {
        prop: 'target.url',
        label: this.$t('banner.targetUrl'),
        renderCell: {
          required: true,
          component: 'input'
        }
      }
    ]
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'banners.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'banners.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/banners',
    name: 'banners.index',
    component: Banners,
    props: {
      type: 'index',
    }
  },
  {
    path: '/banners/new',
    name: 'banners.new',
    component: Banners,
    props: {
      type: 'new',
    }
  },
  {
    path: '/banners/:id',
    name: 'banners.show',
    component: Banners,
    props: {
      type: 'show',
    }
  },
  {
    path: '/banners/:id/edit',
    name: 'banners.edit',
    component: Banners,
    props: {
      type: 'edit'
    }
  }
]
</script>
